import React, { PureComponent, Suspense, lazy } from 'react';
import { connect } from 'react-redux'
import { Link } from "react-router-dom";
import { LazyImage } from 'react-lazy-images';
import qs from 'qs';

import './home.scss';
import { fetchFeatured } from './actions';
import arrowIcon from '../../assets/img/next-icon-gradient.svg';

import ImageClient from '../../helpers/imageHandler';

const Search = lazy(() => import('../../components/search/Search'));

class Home extends PureComponent {

    constructor(props) {
        super(props);

        this.state = {
            searchTerm: ''
        };

        this.props.fetchFeatured();

        this.handleSearch = this.handleSearch.bind(this);
    }

    handleSearch(e) {
        e.preventDefault();
        this.props.history.push(`/products/?${qs.stringify({searchterm: this.state.searchTerm})}`);
    }

    render() {
        const { featuredProducts } = this.props;
        const { featuredRecipes } = this.props;

        const featuredProduct = featuredProducts.map((product, index) => {
            const thumbPath = ImageClient.fitIn(product.thumbnail || product.image, { width: 180, height: 250 });
            return (
                <Link to={`/products/${product.slug}`} className="featured-block flavors" key={index}>
                    <LazyImage
                        src={thumbPath}
                        alt={`Featured Product ${index}`}
                        placeholder={({ imageProps, ref }) => (
                            <div ref={ref}>...</div>
                        )}
                        actual={({ imageProps }) => <img className="flavor-image" alt="" {...imageProps} />}
                    />
                    <div className="flavor-name">{product.name}</div>
                </Link>
            )
        });

        const featuredRecipe = featuredRecipes.map((recipe, index) => {
            const thumbPath = ImageClient.fitIn(recipe.thumbnail || recipe.image, { width: 315, height: 210 });
            return (
                <Link to={`/recipes/${recipe.slug}`} className="featured-block recipes" key={index}>
                    <div className="recipe-image">
                        <LazyImage
                            src={thumbPath}
                            alt={`Featured Recipe ${index}`}
                            placeholder={({ imageProps, ref }) => (
                                <div ref={ref}>...</div>
                            )}
                            actual={({ imageProps }) => <img alt="" {...imageProps} />}
                        />
                        <div className="recipe-name">{recipe.name}</div>
                    </div>
                </Link>
            )
        });

        return (
            <div>
                <div className="hero-wrapper home">
                    <Link to="/collections" className="promo">Our Favorite<br/>Recipe Collections</Link>
                    <div className="hero-block">
                        <h2>With over</h2>
                        <h1>60 flavors</h1>
                        <h3>to make any day<br/> a perfect one</h3>
                    </div>
                    <form onSubmit={this.handleSearch} data-gtm-home-search-link-a>
                        <Suspense fallback={null}>
                            <Search
                                placeholder={'Type product name'}
                                onChange={(e) => {this.setState({searchTerm: e.target.value})}}
                            />
                        </Suspense>
                    </form>
                </div>
                <div className="body-wrapper">
                    <div className="column-block-50">
                        <div className="block-title">
                            <h3>Featured Flavors</h3>
                            <Link to="/products">See more <img className="arrow-link" src={arrowIcon} alt="see more" /></Link>
                        </div>
                        <div className="featured-wrapper">
                            {featuredProduct}
                        </div>
                    </div>
                    <div className="column-block-50">
                        <div className="block-title">
                            <h3>Quick and Simple Cooking at Home</h3>
                            <Link to="/recipes/easy-home-recipes">See more <img className="arrow-link" src={arrowIcon} alt="see more" /></Link>
                        </div>
                        <div className="featured-wrapper">
                            {featuredRecipe}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    featuredProducts: state.products.featured,
    featuredRecipes: state.recipes.featured
});

export default connect(mapStateToProps, { fetchFeatured })(Home);
